const MAXIMUM_ANNOUNCEMENT_HEIGHT = 100;

export {MAXIMUM_ANNOUNCEMENT_HEIGHT};
